import styled from 'styled-components';
import FluffyCard from '@gotamedia/fluffy/Card';
const DescriptionWrapper = styled.div.withConfig({
  displayName: "style__DescriptionWrapper",
  componentId: "sc-1mn02vj-0"
})(["display:flex;flex-direction:column;width:100%;margin:0 15px 0 0;"]);
const DescriptionName = styled(FluffyCard.Paragraph).withConfig({
  displayName: "style__DescriptionName",
  componentId: "sc-1mn02vj-1"
})(["font-weight:700;margin-bottom:0;color:#2E2A25;"]);
const DescriptionValue = styled(FluffyCard.Paragraph).withConfig({
  displayName: "style__DescriptionValue",
  componentId: "sc-1mn02vj-2"
})(["-webkit-line-clamp:1;display:-webkit-box !important;-webkit-box-orient:vertical;white-space:normal;overflow:hidden;"]);
export { DescriptionWrapper, DescriptionName, DescriptionValue };